import { render, staticRenderFns } from "./ProdutosMaisVendidos.vue?vue&type=template&id=5c761439&scoped=true&"
import script from "./ProdutosMaisVendidos.vue?vue&type=script&lang=js&"
export * from "./ProdutosMaisVendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c761439",
  null
  
)

export default component.exports